var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3337 13.9583C20.3337 13.2996 20.3337 12.9702 20.2613 12.7C20.0648 11.9667 19.492 11.3939 18.7586 11.1974C18.4884 11.125 18.1591 11.125 17.5003 11.125C16.8416 11.125 16.5122 11.125 16.242 11.1974C15.5087 11.3939 14.9359 11.9667 14.7394 12.7C14.667 12.9702 14.667 13.2996 14.667 13.9583M12.6837 23.875H22.317C23.1104 23.875 23.5071 23.875 23.8101 23.7206C24.0767 23.5848 24.2934 23.368 24.4293 23.1015C24.5837 22.7984 24.5837 22.4017 24.5837 21.6083V16.225C24.5837 15.4316 24.5837 15.0349 24.4293 14.7318C24.2934 14.4653 24.0767 14.2486 23.8101 14.1127C23.5071 13.9583 23.1104 13.9583 22.317 13.9583H12.6837C11.8903 13.9583 11.4935 13.9583 11.1905 14.1127C10.9239 14.2486 10.7072 14.4653 10.5714 14.7318C10.417 15.0349 10.417 15.4316 10.417 16.225V21.6083C10.417 22.4017 10.417 22.7984 10.5714 23.1015C10.7072 23.368 10.9239 23.5848 11.1905 23.7206C11.4935 23.875 11.8903 23.875 12.6837 23.875Z",
    stroke: "#09041C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeCountIcon);
export default __webpack_public_path__ + "static/media/employee-count-icon.f75aa6f66c3a7cfd4e59ae0b69b0afbc.svg";
export { ForwardRef as ReactComponent };